module.exports = __webpack_public_path__ + "media/images/logo-mobile-c385554ec241713527fcc6dc9491f81d.svg";